<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-content-detection`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 32v8h8v4H6a2 2 0 01-2-2V32h4zm33.339-5.425l2.828 2.829-14.142 14.142-8.485-8.485 2.828-2.829 5.657 5.657L41.34 26.575zM16 4v4H8v8H4V6a2 2 0 012-2h10zm26 0a2 2 0 012 2v10h-4V8h-8V4h10z"/></svg>
</template>
<script>

export default {
  name: 'IconContentDetection',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
